export const GFPP_ACTIONS = {
    SETTINGS: 'settings',
    LAYOUT: 'layout',
    STYLABLE_LAYOUT: 'stylableLayout',
    DESIGN: 'design',
    STYLABLE: 'stylable',
    BACKGROUND: 'background',
    UPGRADE: 'upgrade',
    FILTERS: 'filters',
    BEHAVIORS: 'behaviors',
    EFFECTS: 'effects',
    CROP: 'crop',
    AVIARY: 'aviary',
    ANIMATION: 'animation',
    LINK: 'link',
    HIDE: 'hide',
    HELP: 'help',
    STRETCH: 'stretch',
    STRETCH_FOR_COLUMNS: 'stretchForColumns',
    PIN_MODE: 'pinMode',
    CONNECT: 'connect',
    MANAGE: 'manage',
    CUSTOMIZE_DESIGN: 'customizeDesign',
    APPLY_TO_OTHER_VIEW: 'applyToOtherView',
    PREVIEW: 'preview',
    CHANGE_MEDIA: 'changeMedia',
    SCALE_UP: 'scale_up',
    SCALE_DOWN: 'scale_down',
};
//# sourceMappingURL=gfppActions.js.map